"use client";

import React from "react";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import WhyChooseSection from "./components/WhyChooseSection";
import HowItWorksSection from "./components/HowItWorksSection";
import PopularCategoriesSection from "./components/PopularCategoriesSection";
import CTASection from "./components/CTASection";

export default function CustomerWorkflowPage() {
  return (
    <div className="bg-white relative w-full min-h-screen" data-name="Customer Workflow Page">
      <div className="relative content-stretch flex flex-col gap-[32px] items-center w-full pt-0 2xl:pt-6">
        <HeroSection />
        <AboutSection />
        <WhyChooseSection />
        <HowItWorksSection />
        <PopularCategoriesSection />
        <CTASection />
      </div>
    </div>
  );
}
